/** Screen-space drag handle above an edgeless element: its footprint does not shrink with canvas zoom. */
export const EDGELESS_HANDLE_GEOMETRY = {
  width: 46,
  height: 22,
  gap: 16,
} as const;

/** Screen-space distance from an element edge that the drag handle occupies. */
export const EDGELESS_HANDLE_CLEARANCE =
  EDGELESS_HANDLE_GEOMETRY.height + EDGELESS_HANDLE_GEOMETRY.gap;

/** Screen-space hit area of an auto-complete (expansion) arrow. */
export const EDGELESS_AUTO_COMPLETE_ARROW_GEOMETRY = {
  width: 72,
  height: 44,
} as const;

/** Room a focused element keeps to a view edge with nothing docked along it. */
export const EDGELESS_FOCUS_EDGE = 24;

/** Room a focused element keeps beyond an overlay docked along the view's top edge. */
export const EDGELESS_FOCUS_OVERLAY_GAP = 12;

/**
 * Room a focused element keeps to the view, [top, right, bottom, left] in screen px, given the insets
 * of the overlays docked to the view's edges (minimap, the app's dock). Above it the drag handle stays
 * visible below a top overlay's band; every other side keeps EDGELESS_FOCUS_EDGE beyond its overlay
 * band. Expansion arrows may reach into the room.
 */
export function edgelessFocusPadding(
  overlayInsets: readonly [number, number, number, number]
): [number, number, number, number] {
  const [top, right, bottom, left] = overlayInsets;
  return [
    (top > 0 ? top + EDGELESS_FOCUS_OVERLAY_GAP : EDGELESS_FOCUS_EDGE) +
      EDGELESS_HANDLE_CLEARANCE,
    right + EDGELESS_FOCUS_EDGE,
    bottom + EDGELESS_FOCUS_EDGE,
    left + EDGELESS_FOCUS_EDGE,
  ];
}

/** Highest zoom a focus brings a small element to: it fills the free view without blowing up. */
export const EDGELESS_FOCUS_MAX_ZOOM = 2;
